import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import {
  distanceQuantityField,
  distanceUnitField,
  passengerQuantityField,
  transportationModeField,
  tripKindField,
} from './common/travelFields';

export const travelRailMetadata = {
  displayName: msg({
    message: 'Rail travel',
    context: 'Activity data schema name for rail travel',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    distance_quantity: distanceQuantityField,
    // NOTE: quantity does not exist on the BAT but distance_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: distanceQuantityField,
    distance_unit: distanceUnitField,
    passenger_quantity: passengerQuantityField,
    transportation_mode: transportationModeField,
    trip_kind: tripKindField,
  },
} as const satisfies BatMetadataConfigEntry;
